/**
 * User-facing copy aligned with dashboard-desktop-app pepLoginUiCopy / loginToPep.html.
 */
export const PEP_LOGIN_TITLE = 'Login to Hilton PEP'

export const PEP_LOGIN_SUBTITLE = 'Sign in to your Hilton PEP account'

export const PEP_LOGIN_LABEL_USERNAME = 'Username'

export const PEP_LOGIN_LABEL_PASSWORD = 'Password'

export const PEP_LOGIN_LABEL_LOGIN_URL = 'Login URL'

export const PEP_LOGIN_PLACEHOLDER_USERNAME = 'Enter your username'

export const PEP_LOGIN_PLACEHOLDER_PASSWORD = 'Enter your password'

export const PEP_LOGIN_PLACEHOLDER_LOGIN_URL = 'Enter PEP login URL'

export const PEP_LOGIN_BUTTON_SIGN_IN = 'Sign In'

export const PEP_LOGIN_BUTTON_CANCEL = 'Cancel'

export const PEP_LOGIN_LOADING_TEXT = 'Signing in...'

export const PEP_LOGIN_FOOTER = 'Secure login powered by Directful Dashboard'

export const PEP_LOGIN_URL_TOOLTIP_LINES = [
  'https://login.pep.hilton.com/hk-home/index.html#/',
  'https://enterprise.pep-pv.hilton.com/hk-home/index.html#/'
]

export const PEP_LOGIN_DEFAULT_URL =
  'https://login.pep.hilton.com/hk-home/index.html#/'

export const PEP_LOGIN_SNOOZE_PROMPT = "Can't sign in right now?"

export const PEP_LOGIN_SNOOZE_PLACEHOLDER = 'Remind me later…'

export const PEP_LOGIN_SNOOZE_OPTIONS = [
  { minutes: 30, label: 'In 30 minutes' },
  { minutes: 60, label: 'In 1 hour' },
  { minutes: 120, label: 'In 2 hours' },
  { minutes: 360, label: 'In 6 hours' }
]

const STEP_MESSAGES = {
  credentials: 'Enter your Hilton username, password, and Login URL.',
  auto_login:
    'Hilton PEP sign-in failed. Check your credentials and Login URL, then try again.',
  auto_login_unhandled:
    'Hilton PEP sign-in failed unexpectedly. Try again in a moment.',
  ipc_handler: 'Could not start Hilton PEP sign-in. Try again.',
  'Launch HK Home':
    'Could not open the Hilton PEP login page. Check the Login URL (production vs PEP Preview).',
  'Login Form Submission':
    'Could not submit your Hilton username. Confirm the Login URL and try again.',
  'Password Form Detection':
    'Hilton did not show the password page. Check the username and Login URL.',
  'Password Form Submission': 'Could not submit your Hilton password. Try again.',
  'Mini Objects Request Capture':
    'Hilton sign-in did not finish or the session was not captured. Check username, password, and Login URL (use enterprise.pep-pv.hilton.com for PEP Preview).',
  hilton_signin_incomplete:
    'Hilton sign-in did not finish. Check your username and password. If you use PEP Preview, set Login URL to enterprise.pep-pv.hilton.com.',
  hilton_auth_not_captured:
    'Hilton PEP sign-in could not be completed in time. Try again. If it keeps failing, verify username, password, and Login URL.',
  'Token Verification':
    'Hilton signed in, but access for this hotel could not be verified. Confirm this account can open the property in PEP, and that the Login URL matches production or PEP Preview.',
  'Hotel Config Request':
    'Hilton signed in, but the hotel list could not be loaded for this account. Try Sign In again. If it keeps failing, confirm the account can open the property in PEP and that the Login URL is correct.',
  'Login Process':
    'Hilton PEP sign-in failed. Check your credentials and Login URL, then try again.',
  login_busy:
    'Another Hilton sign-in is still finishing. Wait a few seconds and try Sign In again.',
  login_superseded:
    'Hilton sign-in was interrupted. Try Sign In again.',
  'unknown step': 'Hilton PEP sign-in failed. Try again.'
}

/**
 * @param {string} [step]
 * @param {string} [detail] Prefer desktop-provided operator message when present.
 * @returns {string}
 */
export function formatPepLoginError(step, detail) {
  if (typeof detail === 'string' && detail.trim() !== '') {
    return detail.trim()
  }
  if (!step) {
    return 'Hilton PEP sign-in failed. Try again.'
  }
  return (
    STEP_MESSAGES[step] ||
    'Hilton PEP sign-in failed. Check your credentials and Login URL, then try again.'
  )
}
